import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';

import useFigPiiExperiment from '@nubank/www-latam-commons/utils/figpii/useFigPiiExperiment';

import { useSiteContext } from '../../../../../../../../components/SiteContext/SiteContext';
import CommsReminder from '../../CommsReminder';
import { MAGIC_LINK_FIX_EXPERIMENT_ID, MAGIC_LINK_FIX_EXPERIMENT_VARIANT } from '../../../../../../../../utils/experiments';

import MagicLinkBtn from './MagicLinkBtn';
import AppStoreButtons from './AppStoreButtons';

const StyledTitle = styled(Typography)`
  font-size: 28px;

  @media (width >= 768px) {
    font-size: 2.1rem;
  }
`;

const MainText = () => {
  const { email, phone } = useSiteContext();
  const activeVariant = useFigPiiExperiment(MAGIC_LINK_FIX_EXPERIMENT_ID);

  return (
    <Box>
      {/* TITLE AND SUBTITLE */}
      <StyledTitle
        variant="heading2"
        marginTop="6x"
      >
        ¡Ya tenemos tu oferta lista en la app! 🥳️
      </StyledTitle>

      <Typography
        variant="subtitle1"
        marginTop="4x"
        whiteSpace="pre-line"
        strong
      >
        <Typography strong tag="span" variant="subtitle1" color="primary">
          Continúa
        </Typography>
        {' para terminar de contratar tu oferta.'}
      </Typography>

      <CommsReminder email={email} phone={phone} />

      {/* MAGIC LINK BUTTON */}

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginBottom="4x"
        marginTop="8x"
      >
        {activeVariant === MAGIC_LINK_FIX_EXPERIMENT_VARIANT ? (
          <AppStoreButtons />
        ) : (
          <MagicLinkBtn />
        )}
      </Box>

      {/* IMAGE BLOCK */}

      <Typography variant="subtitle1" strong>
        Tu oferta te está esperando:
      </Typography>
    </Box>
  );
};

export default MainText;
